import { CartViewModel } from "../model/Cart/CartViewModel";
import { ModuleSelectionViewModel } from "../model/ExamSignup/ModuleSelectionViewModel";

export default class ErrorHelper {
  public static GetErrors(cart?: CartViewModel): string[] {
    var allErrors: string[] = [];

    if (cart?.modules) {
      allErrors = ErrorHelper.GetModuleErrors(cart.modules);
    }

    return allErrors;
  }

  public static GetModuleErrors(modules: ModuleSelectionViewModel[]): string[] {
    var allErrors: string[] = [];
    // note module.Errors is a list of strings and can contain various errors for each module.
    modules?.forEach((module) => {
      if ((module.errors?.length ?? 0) > 0) {
        module.errors?.forEach((err) => {
          if (err && (err?.length ?? 0) > 0) {
            if (!allErrors.includes(err)) {
              allErrors = allErrors.concat(err);
            }
          }
        });
      }
    });
    
    return allErrors;
  }
}
